import { z } from 'zod';
import { validateJsonSchemaString } from '../../../../lib/validate-json-schema';

export const extractionFormSchema = z.object({
  name: z.string().min(1, 'Required'),
  description: z.string(),
  prompt: z.string().min(1, 'Required'),
  outputSchema: z.string().superRefine((val, ctx) => {
    const result = validateJsonSchemaString(val);
    if (!result.ok) {
      ctx.addIssue({ code: z.ZodIssueCode.custom, message: result.message ?? 'Invalid schema' });
    }
  }),
});

export type ExtractionFormValues = z.infer<typeof extractionFormSchema>;
